if (!customElements.get('countdown-loader')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      
      // Better date parsing with error handling
      try {
        this.startDate = this.dataset.startDate ? new Date(this.dataset.startDate).getTime() : Date.now();
        this.endDate = new Date(this.dataset.endDate).getTime();
        
        // Check if dates are valid
        if (isNaN(this.startDate) || isNaN(this.endDate)) {
          console.error('Invalid date format in countdown timer');
          return;
        }
        
        this.totalSeconds = (this.endDate - this.startDate) / 1000;
        
        // Initialize the timer
        this.init();
      } catch (error) {
        console.error('Error initializing countdown timer:', error);
      }
    }

    init() {
      // Get timer elements with error checking
      this.daysEl = this.querySelector('#days') || this.querySelector('.day');
      this.hoursEl = this.querySelector('#hours') || this.querySelector('.hour');
      this.minsEl = this.querySelector('#minutes') || this.querySelector('.minute');
      this.secsEl = this.querySelector('#seconds') || this.querySelector('.second');
      
      // Check if all required elements exist
      if (!this.daysEl || !this.hoursEl || !this.minsEl || !this.secsEl) {
        console.error('Required timer elements not found');
        return;
      }
      
      // Progress elements (optional - may not exist in all implementations)
      this.progressEl = document.querySelector('.progress');
      this.progressElGlow = document.getElementById('progress-glow');

      // Time constants
      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;

      // Start the timer
      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), this.second);
    }

    formatTime(time) {
      return time < 10 ? `0${time}` : time;
    }

    updateTimer() {
      const now = Date.now();
      const timeDiff = this.endDate - now;

      // If countdown has ended
      if (timeDiff <= 0) {
        this.clearTimer();
        return;
      }

      // Calculate time units
      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor((timeDiff % this.day) / this.hour);
      const mins = Math.floor((timeDiff % this.hour) / this.minute);
      const secs = Math.floor((timeDiff % this.minute) / this.second);

      // Update display
      this.daysEl.textContent = this.formatTime(days);
      this.hoursEl.textContent = this.formatTime(hours);
      this.minsEl.textContent = this.formatTime(mins);
      this.secsEl.textContent = this.formatTime(secs);

      // Update progress if elements exist
      this.updateProgress(now);
    }

    updateProgress(currentTime) {
      // Only update progress if progress elements exist
      if (!this.progressEl) return;
      
      const totalDuration = this.endDate - this.startDate;
      const timeRemaining = this.endDate - currentTime;
      
      // Calculate progress percentage
      let progress = (timeRemaining / totalDuration) * 100;
      progress = Math.max(0, Math.min(progress, 100));
      
      const progressPercentage = 100 - progress;
      
      // Update progress bar
      this.progressEl.style.background = `linear-gradient(to right, transparent ${progressPercentage}%, #ecf0f1 ${progressPercentage}%)`;
      
      // Update glow effect if it exists
      if (this.progressElGlow) {
        this.progressElGlow.style.background = `linear-gradient(to right, transparent ${progressPercentage}%, #ecf0f1 ${progressPercentage}%)`;
      }
    }

    clearTimer() {
      // Clear the interval
      if (this.interval) {
        clearInterval(this.interval);
      }
      
      // Reset all timer displays to 00
      if (this.daysEl) this.daysEl.textContent = "00";
      if (this.hoursEl) this.hoursEl.textContent = "00";
      if (this.minsEl) this.minsEl.textContent = "00";
      if (this.secsEl) this.secsEl.textContent = "00";
      
      // Reset progress bars if they exist
      if (this.progressEl) {
        this.progressEl.style.background = 'linear-gradient(to right, transparent 100%, #ecf0f1 100%)';
      }
      
      if (this.progressElGlow) {
        this.progressElGlow.style.background = 'linear-gradient(to right, transparent 100%, #ecf0f1 100%)';
      }
      
      // Hide progress wrapper and show end text if they exist
      const progressWrapper = document.querySelector('.progress-wrapper');
      if (progressWrapper) {
        progressWrapper.style.display = 'none';
      }
      
      const endText = document.querySelector('.countdown-end-text');
      if (endText) {
        endText.style.display = 'block';
      }
      
      // Dispatch custom event for countdown end
      this.dispatchEvent(new CustomEvent('countdownEnd', {
        bubbles: true,
        detail: { message: 'Countdown has ended' }
      }));
    }

    // Method to manually destroy the timer
    destroy() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  // Define the custom element
  customElements.define('countdown-loader', CountdownTimer);
}